import { useT } from "../../i18n";

export const Differentiator = () => {
  const t = useT();
  return (
    <section
      id="approach"
      className="sp-section"
      data-testid="section-approach"
    >
      <div className="sp-container">
        <div className="sp-diff-layout">
          <div className="sp-reveal">
            <span className="sp-eyebrow">{t.differentiator.eyebrow}</span>
            <h2 className="sp-title">{t.differentiator.title}</h2>
            <p className="sp-lead">{t.differentiator.lead}</p>
            <div className="sp-diff-list">
              {t.differentiator.pillars.map((p) => (
                <div className="sp-diff-item" key={p.title}>
                  <div className="sp-diff-icon" aria-hidden="true" />
                  <div>
                    <h4>{p.title}</h4>
                    <p>{p.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="sp-diff-quotes sp-reveal" data-testid="approach-quotes">
            {t.differentiator.quotes.map((qt, i) => (
              <div className="sp-diff-quote" key={i}>
                <blockquote>{qt.q}</blockquote>
                <cite>{qt.c}</cite>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
